import { Suspense } from "react";
import {
  CircularProgress,
  IconButton,
  styled,
  Typography,
} from "@mui/material";
import { Edit } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import { useCurrentUser } from "marvin-auth-kit";
import { useConfig } from "../hooks/settingHooks";
import { TokenUser } from "../types";
import { AboutLoader } from "../components/about/AboutLoader";
import { FlexCentered } from "../components/layout/FlexCenterd";
import { NavLink } from "../components/navigation/NavLink";
import { PaddedPaper } from "../components/surfaces/PaddedPaper";

export function InfoPage() {
  const config = useConfig();
  const currentUser = useCurrentUser<TokenUser | undefined>();
  const { t } = useTranslation();

  return (
    <StyledPaddedPaper elevation={0}>
      <div className="flex-title">
        <Typography variant="h6" color="primary">
          {t("label.information")}
        </Typography>
        {currentUser && currentUser.roles.includes("root") && (
          <IconButton
            color="primary"
            aria-label="edit about page"
            component={NavLink}
            to={`/${config}/admin/info`}
          >
            <Edit fontSize="small" />
          </IconButton>
        )}
      </div>
      <Suspense
        fallback={
          <FlexCentered>
            <CircularProgress />
          </FlexCentered>
        }
      >
        {config && <AboutLoader config={config} />}
      </Suspense>
    </StyledPaddedPaper>
  );
}

const StyledPaddedPaper = styled(PaddedPaper)`
  .flex-title {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }
`;
